import { Outlet } from "react-router-dom";

const PostRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PostRoot;
